<app-main-layout>
  <div class="bg-gray-50 min-h-screen">
  <div class="py-6 px-4 sm:px-6 max-w-[1100px] mx-auto">

    <!-- Header -->
    <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-6">
      <div class="flex items-center gap-4 min-w-0">
        <button type="button" (click)="backToList()"
          class="h-10 w-10 flex-shrink-0 rounded-full bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:text-gray-900 hover:border-amber-300 transition-colors"
          matTooltip="Back to landscapers" aria-label="Back to landscapers">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <span class="h-12 w-12 rounded-xl flex items-center justify-center font-bold flex-shrink-0"
          [ngClass]="landscaper?.isApproved ? 'bg-neutral-900 text-amber-400' : 'bg-gradient-to-br from-amber-300 to-amber-500 text-neutral-900'">
          @if (landscaper) { {{ initials(landscaper) }} } @else { <mat-icon>handyman</mat-icon> }
        </span>
        <div class="min-w-0">
          <div class="flex items-center gap-1.5 text-xs text-gray-400">
            <button type="button" class="hover:text-gray-700" (click)="backToList()">Landscapers</button>
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">chevron_right</mat-icon>
            <span>{{ isEdit ? 'Edit' : 'New' }}</span>
          </div>
          <h1 class="text-2xl font-bold text-gray-900 tracking-tight truncate max-w-[70vw] lg:max-w-[520px]">{{ loading ? 'Loading…' : landscaper?.storeName || 'New landscaper' }}</h1>
          @if (landscaper) {
            <div class="mt-0.5 flex flex-wrap items-center gap-1.5 text-xs">
              @if (landscaper.isApproved) { <span class="font-semibold px-2 py-0.5 rounded-md bg-emerald-50 text-emerald-700">Live on the website</span> }
              @else { <span class="font-semibold px-2 py-0.5 rounded-md bg-amber-100 text-amber-800">Awaiting approval</span> }
              @if (!landscaper.hasLocation) { <span class="font-semibold px-2 py-0.5 rounded-md bg-rose-50 text-rose-700">Not on the map</span> }
              @if (landscaper.duplicateIds?.length) { <span class="font-semibold px-2 py-0.5 rounded-md bg-violet-50 text-violet-700">Possible duplicate of #{{ landscaper.duplicateIds!.join(', #') }}</span> }
            </div>
          } @else if (!isEdit) {
            <p class="text-xs text-gray-500">Added here, they are listed on the website straight away unless you untick it</p>
          }
        </div>
      </div>
      <div class="flex items-center gap-2 flex-wrap">
        @if (isEdit && navTotal) {
          <app-record-nav noun="landscaper" listName="Landscapers" [position]="position" [total]="navTotal"
            [prevName]="prev?.l?.storeName ?? null" [nextName]="next?.l?.storeName ?? null" [disabled]="loading" (prev)="goTo(prev)" (next)="goTo(next)"></app-record-nav>
        }
        @if (landscaper && !landscaper.isApproved) {
          <button type="button" [disabled]="approving" (click)="approve()"
            class="flex items-center gap-1.5 px-4 py-2.5 rounded-xl bg-gradient-to-b from-emerald-400 to-emerald-500 text-white text-sm font-bold shadow-sm shadow-emerald-200 hover:from-emerald-300 hover:to-emerald-400 transition-all disabled:opacity-50">
            @if (approving) { <span class="inline-block h-4 w-4 rounded-full border-2 border-white border-t-transparent animate-spin"></span> }
            @else { <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">public</mat-icon> }
            Approve
          </button>
        }
      </div>
    </div>

    @if (loading) {
      <div class="rounded-2xl bg-white border border-gray-100 py-24 flex flex-col items-center justify-center text-sm text-gray-500">
        <mat-spinner diameter="40"></mat-spinner><span class="mt-3">Loading landscaper&hellip;</span>
      </div>
    } @else if (notFound) {
      <div class="rounded-3xl border-2 border-dashed border-gray-200 bg-white py-16 text-center">
        <span class="mx-auto h-14 w-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center"><mat-icon class="!text-[28px] !h-7 !w-7">search_off</mat-icon></span>
        <p class="mt-3 text-sm font-semibold text-gray-700">That landscaper doesn't exist</p>
        <button type="button" class="mt-4 text-xs font-semibold text-amber-700 hover:underline" (click)="backToList(true)">Back to landscapers</button>
      </div>
    } @else if (formData) {
      <app-create-edit-landscaper [pageData]="formData" (done)="onDone($event)"></app-create-edit-landscaper>
    }
  </div>
  </div>
</app-main-layout>
